import { render, staticRenderFns } from "./WizardFormTemplate.vue?vue&type=template&id=09bca518&scoped=true&"
import script from "./WizardFormTemplate.vue?vue&type=script&lang=js&"
export * from "./WizardFormTemplate.vue?vue&type=script&lang=js&"
import style0 from "./WizardFormTemplate.vue?vue&type=style&index=0&id=09bca518&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09bca518",
  null
  
)

export default component.exports